export default function fixtureReducers (state='', action)	 {
	switch (action.type) {
		case 'Loading':
			return action.payload;
		case 'fixture':
			return action.payload;
		case 'ErrorFixture':
			return action.payload;
		default:
			return state;
	}
}